/**
 * Verification Failed Component
 * Based on Figma: https://www.figma.com/design/8nBzg5I71TF3EWyr6NcpVa/Fiat?node-id=4021-78675
 */
import { CircleAlert } from 'lucide-react';

import { Button } from '@components/ui/button';

interface VerificationFailedProps {
  /**
   * Optional error message to display
   */
  error?: string;
  /**
   * Callback when "Contact us" button is clicked
   */
  onContactUs: () => void;
  /**
   * Callback when "Got it" button is clicked
   */
  onGotIt: () => void;
}

export function VerificationFailed({
  error,
  onContactUs,
  onGotIt,
}: VerificationFailedProps) {
  return (
    <div className="pt-5 sm:w-[394px]">
      {/* Content Section */}
      <div className="flex flex-col gap-3">
        {/* Warning Icon */}
        <CircleAlert className="size-6" />
        <h2 className="text-foreground">Verification unsuccessful</h2>
        <p className="text-muted-foreground text-body-paragraph1">
          {error ||
            'We couldn’t verify the additional information provided. Cash transfers will remain restricted. Please contact us if you need assistance.'}
        </p>
      </div>

      {/* Action Buttons */}
      <div className="mt-6 flex gap-4">
        <Button
          type="button"
          variant="secondary"
          onClick={onContactUs}
          className="flex-1"
        >
          Contact us
        </Button>
        <Button
          type="button"
          variant="primary"
          onClick={onGotIt}
          className="flex-1"
        >
          Got it
        </Button>
      </div>
    </div>
  );
}
